import { BuildClass, fsmData } from '../../../../universal';
import { React, _ } from '../../../lib';
import { LoadingSpinnerLarge } from '../loading';
import { ReportJobManagerOption, StubMessage } from './ui-options';
export const ReportJobGlobalParams = (props) => {
    if (!props.rs.state.cache?.params) {
        return React.createElement(LoadingSpinnerLarge, null);
    }
    const rj = props.rs.state.reportJobs[props.rj ?? -1];
    if (!rj) {
        return React.createElement(StubMessage, { msg: "Select a report job" });
    }
    const all_options = getUsedOptionTypes(props.rs, rj);
    if (all_options.length === 0) {
        return React.createElement(StubMessage, { msg: "No available options" });
    }
    const defined_options = fsmData(all_options, {
        filter: x => _.has(rj.BaseParams, x.key),
        map: x => x.key,
    });
    const report_order = _.map(props.rs.props.reportIndex, x => x.Key);
    const name_to_Key = _.fromPairs(_.map(props.rs.props.reportIndex, x => [x.Title, x.Key]));
    return (React.createElement("div", { className: "w-full h-full overflow-y-scroll" }, _.chain(all_options)
        .groupBy(x => x.group)
        .entries()
        .sortBy(x => report_order.indexOf(name_to_Key[x[0]] ?? ''))
        .filter(([, params]) => {
        if (!props.rs.state.compactView) {
            return true;
        }
        return _.some(params, x => defined_options.includes(x.key));
    })
        .map(([groupName, params]) => (React.createElement(React.Fragment, { key: groupName },
        React.createElement("div", { className: "text-lg mt-3 px-3" }, groupName),
        fsmData(params, {
            filter: x => !props.rs.state.compactView ||
                defined_options.includes(x.key),
            map: x => (React.createElement(GlobalParam, { key: x.key, rs: props.rs, rj: rj, isDefined: defined_options.includes(x.key), param: x })),
        }))))
        .value()));
};
const GlobalParam = (props) => {
    const blackoutCover = (React.createElement("a", { className: BuildClass({
            'block text-center text-sm cursor-pointer': true,
            'bg-neutral-200 text-neutral-600': true,
            'hover:text-neutral-950 hover:bg-yellow-100': true,
        }), onClick: e => {
            e.preventDefault();
            props.rs.updateState(s => {
                const sRJ = props.rs.state.reportJobs[props.rj.ID];
                if (!sRJ) {
                    return {};
                }
                return {
                    ...s,
                    reportJobs: {
                        ...props.rs.state.reportJobs,
                        [props.rj.ID]: {
                            ...sRJ,
                            BaseParams: {
                                ...sRJ.BaseParams,
                                [props.param.key]: null,
                            },
                        },
                    },
                };
            });
        } }, "Enable param"));
    const actionButton = (React.createElement("button", { className: "opacity-60 hover:opacity-100 cursor-pointer", title: "Disable this global parameter. All reports will need to define their own individual value.", onClick: e => {
            console.log({ e: _.cloneDeep(e) });
            props.rs.updateState(s => {
                const sRJ = props.rs.state.reportJobs[props.rj.ID];
                if (!sRJ) {
                    return {};
                }
                return {
                    ...s,
                    reportJobs: {
                        ...props.rs.state.reportJobs,
                        [props.rj.ID]: {
                            ...sRJ,
                            BaseParams: _.omit(sRJ.BaseParams, props.param.key),
                        },
                    },
                };
            });
        } },
        React.createElement("img", { className: "w-[14px] mx-[2px]", src: "/static/img/i8/color-unavailable.svg" })));
    return (React.createElement(ReportJobManagerOption, { rs: props.rs, optionType: props.param.type, lbl: props.param.lbl, alwaysShowLabel: true, blackoutCover: !props.isDefined ? blackoutCover : null, actionButton: props.isDefined ? actionButton : null, value: props.rj.BaseParams[props.param.key] ?? null, onUpdate: v => {
            props.rs.updateState(s => {
                const sRJ = s.reportJobs[props.rj.ID];
                if (!sRJ) {
                    return {};
                }
                return {
                    reportJobs: {
                        ...s.reportJobs,
                        [props.rj.ID]: {
                            ...sRJ,
                            BaseParams: {
                                ...sRJ.BaseParams,
                                [props.param.key]: v,
                            },
                        },
                    },
                };
            });
        } }));
};
const getUsedOptionTypes = (rs, rj) => {
    const report_names = _.fromPairs(_.map(rs.props.reportIndex, x => [x.Key, x.Title]));
    return _.chain(rj.Reports)
        .flatMap(x => _.map(rs.state.cache?.params[x.Type ?? ''], (p, i) => ({
        key: p.BundlingLabel
            ? `${p.BundlingLabel.replace(/\s/g, '')}-${p.Type}`
            : `${x.Type}-${p.Key}`,
        lbl: p.BundlingLabel ?? p.Label,
        group: p.BundlingLabel
            ? 'Multi-Report'
            : (report_names[x.Type ?? ''] ?? ''),
        type: p.Type,
        index: i,
    })) ?? [])
        .groupBy(x => x.key)
        .map(x => ({
        key: _.first(x)?.key ?? '',
        lbl: _.first(x)?.lbl ?? '',
        type: _.first(x)?.type ?? '',
        group: _.first(x)?.group ?? '',
        index: _.chain(x)
            .map(y => y.index)
            .sum()
            .value() / x.length,
    }))
        .sortBy(x => x.index)
        .map(x => ({
        key: x.key,
        lbl: x.lbl,
        type: x.type,
        group: x.group,
    }))
        .value();
};
//# sourceMappingURL=ui-globals.js.map